import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import Tags from '@/components/screens/tags/Tags';
import { TAGS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { ITags } from '@/interfaces/tags.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface ITagsPageProps extends IWidgetsSideBar {
  data: ITags;
}

const TagsPage: NextPage<ITagsPageProps> = ({ data, todayWidget, popularBooksWidget }) => {
  return <Tags data={data} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [dataRes] = await Promise.all([fetch(`${API_URL}tags/?page=1&page_size=${TAGS_FOR_PAGE}`)]);
  const [data] = await Promise.all([dataRes.json()]);

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { data, todayWidget, popularBooksWidget }, revalidate: REVALIDATE_TIME };
};

export default TagsPage;
